<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-text>
            <h6>SATURDAY OCTOBER 12TH, 2019
              <br><br>
              <v-divider insert></v-divider>
              <br>
              <i>
              Ceremony: 6:30 pm
              <br>
              Coctail Hour: 7 pm - 8 pm
              <br>
              Dinner, Dancing, Drinks: 8 pm - 12 am
              <br>
              </i>
              <br>
              <a
                href="https://www.google.com/maps/place/New+England+Aquarium/@42.3591346,-71.0519429,17z/data=!3m1!4b1!4m5!3m4!1s0x89e3707d60bfd085:0xdda63d8ad6157d49!8m2!3d42.3591346!4d-71.0497542"
                target="_blank">
              New England Aquarium
              <br>
              1 Central Warf Boston, MA 02110
              </a>
            </h6>
          </v-card-text>
          <v-layout justify-center>
            <v-card-actions>
              <v-btn primary flat to="/directions" style="border: 1px solid grey;">
                <span>DIRECTIONS</span>
              </v-btn>
            </v-card-actions>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  name: 'location-card',
};
</script>

<style scoped>
h1 {
  text-align: center;
  font: 5rem sans-serif;
}
h3 {
  text-align: center;
  font: 3rem sans-serif;
}
h4 {
  text-align: center;
  font: 2rem sans-serif;
}
h5 {
  text-align: center;
  font: 1.4rem sans-serif;
}
h6 {
  text-align: center;
  font: 1rem sans-serif;
}
h6 {
  text-align: center;
  font: 1rem sans-serif;
}

</style>
